const MIN_WEIGHT = 30
const MAX_WEIGHT = 300

const MIN_HEIGHT = 90
const MAX_HEIGHT = 250

const MIN_AGE = 18
const MAX_AGE = 100

isString = (value) => typeof value === "string"

const validators = {
  measurementSystem: (value) => ["imperial", "metric"].includes(value),
  gender: (value) => ["female", "male"].includes(value),
  goal: (value) => ["Lose weight", "Develop healthy habits"].includes(value),
  email: (value) => isString(value) && value.match(/^\S+@\S+\.\S+$/),
  age: (value) => Number(value) >= MIN_AGE && Number(value) <= MAX_AGE,
  targetWeightKg: (value) => !!Number(value),
  targetWeightLbs: (value) => !!Number(value),
  firstName: (value) => isString(value) && value.length > 0 && !!value.trim(),
  weightKg: (value) => Number(value) >= MIN_WEIGHT && Number(value) <= MAX_WEIGHT,
  weightLbs: (value) => {
    const weight = Number(value) * 0.453592

    return weight >= MIN_WEIGHT && weight <= MAX_WEIGHT
  },
  heightCm: (value) => Number(value) >= MIN_HEIGHT && Number(value) <= MAX_HEIGHT,
  heightFt: (value, { heightFt, heightIn }) => {
    const height = Number(heightFt) * 30.48 + Number(heightIn) * 2.54

    return height >= MIN_HEIGHT && height <= MAX_HEIGHT
  },
  heightIn: (value, { heightFt, heightIn }) => {
    const height = Number(heightFt) * 30.48 + Number(heightIn) * 2.54

    return height >= MIN_HEIGHT && height <= MAX_HEIGHT
  },
  privacyAgreement: (value) => value !== "No",
}

const ERROR_MESSAGES = new Proxy(
  {
    weightKg: "Weight entered incorrectly",
    weightLbs: "Weight entered incorrectly",
    age: "Years entered incorrectly",
    heightCm: "Height entered incorrectly",
    heightFt: "Height entered incorrectly",
    heightIn: "Height entered incorrectly",
    firstName: "Name entered incorrectly",
    email: "Entered invalid email",
    privacyAgreement: "(you must agree to the terms to proceed)",
  },
  {
    get: (target, name) => (target.hasOwnProperty(name) ? target[name] : "invalid"),
  }
)

const validate = (data) => {
  const errors = {}
  let hasErrors = false

  Object.entries(data).forEach(([field, value]) => {
    const validator = validators[field]

    if (validator && !validator(value, data)) {
      hasErrors = true
      errors[field] = ERROR_MESSAGES[field]
    }
  })

  return { hasErrors, errors }
}

export default validate
